import { createApp } from "vue";
import { createPinia } from "pinia";

import App from "@/App.vue";
import { initWorkdesk } from "@/services/Workdesk";

import engine from "@/engine";

import componentsLibrary from "@/library/entrypoints/simple";

engine.events.publish(engine.events.list.VUE_BEFORE_INIT, App);
const app = createApp(App);
const pinia = createPinia();
app.use(pinia);
engine.translation.store = engine.translation.initStore();
app.use(componentsLibrary);
engine.registerVueApp(app);
engine.events.publish(engine.events.list.VUE_AFTER_INIT, engine);

engine.events.publish(engine.events.list.VUE_BEFORE_MOUNT, engine);
app.mount(engine.engineConfig.rootElementIdSelector);
engine.events.publish(engine.events.list.VUE_AFTER_MOUNT, engine);
engine.registerFormFunctionality();

if (window.engineAfterLoad) {
  window.engineAfterLoad(engine);
}
engine.events.publish(engine.events.list.ENGINE_READY, engine);

if (engine.engineConfig.workdesk) {
  initWorkdesk(engine);
}
